import { createSelector } from 'reselect';

export const getSettings = (state) => state.settings || {};

export const getSiteId = createSelector([getSettings], (settings) => settings.siteId);
